/* ============================================================
   NOBS & CO — PDP: galeria, variantes (chips), compra AJAX e combo
   ============================================================ */
(function () {
  'use strict';

  // Este arquivo é incluído por mais de uma seção da PDP (produto + compre junto).
  // Sem esta trava ele roda 2x e liga os eventos em dobro — foi o que fazia a
  // quantidade subir de 2 em 2 e o "Adicionar" contar dobrado.
  if (window.__nobsPdpInit) return;
  window.__nobsPdpInit = true;

  var money = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  function formatCents(cents) { return money.format(cents / 100); }

  /* Atualiza as barras de frete que ficam NA PÁGINA (ex: "Complete seu ritual"),
     lendo o carrinho real — em tempo real, sem recarregar. Reaproveita a lógica
     exposta pelo nobs-cart.js. */
  function refreshOnPageBars() {
    if (window.NobsBars && typeof window.NobsBars.refresh === 'function') {
      window.NobsBars.refresh();
    }
  }

  /* Atualiza só o CONTADOR da bolha do carrinho — não mexe no ícone. */
  function refreshCartBubble() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var target = document.getElementById('cart-icon-bubble');
        if (!target) return;
        var bubble = target.querySelector('.cart-count-bubble');
        if (c.item_count > 0) {
          if (!bubble) {
            bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            target.appendChild(bubble);
          }
          bubble.innerHTML = '<span aria-hidden="true">' + (c.item_count < 100 ? c.item_count : '99') + '</span>';
        } else if (bubble) {
          bubble.parentNode.removeChild(bubble);
        }
      })
      .catch(function () {});
  }

  /* Abre o cart drawer do redesign já com o conteúdo atualizado. */
  function tryOpenDrawer() {
    if (window.NobsCart && typeof window.NobsCart.openRefreshed === 'function') {
      window.NobsCart.openRefreshed();
    }
  }

  function addToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  /* ============ PDP principal ============ */
  function initProduct(root) {
    var dataEl = root.querySelector('[data-nobs-variants]');
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var optionCount = parseInt(root.dataset.options, 10) || 1;
    var lowThreshold = parseInt(root.dataset.lowStock, 10) || 0;
    var tierIndex = parseInt(root.dataset.tierIndex, 10) || 0;
    var summaryEl = root.querySelector('[data-nobs-selection]');

    var priceEl = root.querySelector('[data-nobs-price]');
    var compareEl = root.querySelector('[data-nobs-compare]');
    var offEl = root.querySelector('[data-nobs-off]');
    var idInput = root.querySelector('[data-nobs-variant-id]');
    var lowEl = root.querySelector('[data-nobs-lowstock]');
    var lowNumEl = root.querySelector('[data-nobs-lowstock-num]');
    var addBtn = root.querySelector('[data-nobs-atc]');
    var buyBtn = root.querySelector('[data-nobs-buynow]');
    var qtyInput = root.querySelector('[data-nobs-qty]');

    function selectedOptions() {
      var opts = [];
      for (var i = 1; i <= optionCount; i++) {
        var chip = root.querySelector('[data-nobs-chip][data-option-index="' + i + '"].is-selected');
        opts.push(chip ? chip.dataset.value : null);
      }
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        for (var i = 0; i < opts.length; i++) {
          if (opts[i] !== null && v.options[i] !== opts[i]) return false;
        }
        return true;
      });
    }

    function currentVariant() { return findVariant(selectedOptions()); }

    function sync() {
      var v = currentVariant();
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Indisponível'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      // troca a imagem da galeria pela imagem da variante (ex: cor selecionada)
      if (v.media != null && v.media >= 0 && typeof goToSlide === 'function') goToSlide(v.media);
      if (priceEl) priceEl.textContent = formatCents(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = formatCents(v.compare_at_price);
          compareEl.hidden = false;
          if (offEl) {
            var off = Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100);
            offEl.textContent = '-' + off + '%';
            offEl.hidden = false;
          }
        } else {
          compareEl.hidden = true;
          if (offEl) offEl.hidden = true;
        }
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? (addBtn.dataset.label || 'Adicionar ao carrinho') : 'Esgotado';
      }
      if (buyBtn) buyBtn.disabled = !v.available;
      if (lowEl) {
        var show = v.available && lowThreshold > 0 && v.qty !== null && v.qty > 0 && v.qty <= lowThreshold;
        lowEl.hidden = !show;
        if (show && lowNumEl) lowNumEl.textContent = v.qty;
      }
      // marca chips indisponíveis da última opção
      root.querySelectorAll('[data-nobs-chip][data-option-index="' + optionCount + '"]').forEach(function (chip) {
        var opts = selectedOptions();
        opts[optionCount - 1] = chip.dataset.value;
        var vv = findVariant(opts);
        chip.classList.toggle('is-unavailable', !vv || !vv.available);
      });

      // cards da opção "tier": preço por card conforme tamanho/cor atual
      if (tierIndex > 0) {
        root.querySelectorAll('[data-nobs-chip][data-option-index="' + tierIndex + '"]').forEach(function (card) {
          var priceEl = card.querySelector('[data-nobs-tier-price]');
          if (!priceEl) return;
          var opts = selectedOptions();
          opts[tierIndex - 1] = card.dataset.value;
          var vv = findVariant(opts);
          priceEl.textContent = vv ? formatCents(vv.price) : '—';
          card.classList.toggle('is-unavailable', !vv || !vv.available);
          // desconto automático do card (de/por + -X%) a partir do compare_at
          var compEl = card.querySelector('[data-nobs-tier-compare]');
          var offEl2 = card.querySelector('[data-nobs-tier-off]');
          if (vv && vv.compare_at_price && vv.compare_at_price > vv.price) {
            var off2 = Math.round(((vv.compare_at_price - vv.price) / vv.compare_at_price) * 100);
            if (compEl) { compEl.textContent = formatCents(vv.compare_at_price); compEl.hidden = false; }
            if (offEl2) { offEl2.textContent = '-' + off2 + '%'; offEl2.hidden = false; }
          } else {
            if (compEl) compEl.hidden = true;
            if (offEl2) offEl2.hidden = true;
          }
        });
      }

      // linha-resumo da seleção (ex: "Preto · 35/36 · Sem creme")
      if (summaryEl) {
        summaryEl.textContent = selectedOptions()
          .filter(function (o) { return o; })
          .join(' · ');
      }
    }

    root.querySelectorAll('[data-nobs-chip]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var idx = chip.dataset.optionIndex;
        root.querySelectorAll('[data-nobs-chip][data-option-index="' + idx + '"]').forEach(function (c) {
          c.classList.toggle('is-selected', c === chip);
        });
        var labelEl = root.querySelector('[data-nobs-option-current="' + idx + '"]');
        if (labelEl) labelEl.textContent = chip.dataset.value;
        sync();
      });
    });

    // quantidade
    root.querySelectorAll('[data-nobs-qty-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var d = parseInt(btn.dataset.nobsQtyBtn, 10);
        var val = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + d);
        qtyInput.value = val;
      });
    });

    var addonCheckbox = root.querySelector('[data-nobs-addon]');
    if (addonCheckbox) {
      // reflete o estado numa classe (respaldo pra navegadores sem :has)
      var addonLabel = addonCheckbox.closest('.nobs-pp__addon');
      var syncAddon = function () {
        if (addonLabel) addonLabel.classList.toggle('is-checked', addonCheckbox.checked);
      };
      addonCheckbox.addEventListener('change', syncAddon);
      syncAddon();
    }

    // brinde: variante grátis (R$0) que entra sozinha quando o combo escolhido
    // está na lista de combos com brinde (data-gift-tiers)
    var giftVariantId = parseInt(root.dataset.giftVariant, 10) || 0;
    var giftTitle = root.dataset.giftTitle || 'Brinde';
    var giftTiers = (root.dataset.giftTiers || '')
      .toLowerCase().split(/[,\n]/)
      .map(function (s) { return s.trim(); })
      .filter(Boolean);

    function tierEarnsGift() {
      if (!giftVariantId || tierIndex < 1 || !giftTiers.length) return false;
      var val = (selectedOptions()[tierIndex - 1] || '').trim().toLowerCase();
      return val && giftTiers.indexOf(val) !== -1;
    }

    function currentItems() {
      var v = currentVariant();
      if (!v || !v.available) return null;
      var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      var items = [{ id: v.id, quantity: qty }];
      // adicional (esfoliante) marcado: entra como item separado, 1 por kit
      if (addonCheckbox && addonCheckbox.checked && addonCheckbox.dataset.variantId) {
        items.push({ id: parseInt(addonCheckbox.dataset.variantId, 10), quantity: qty });
      }
      // brinde do combo: linha grátis (R$0), 1 por combo
      if (tierEarnsGift()) {
        items.push({
          id: giftVariantId,
          quantity: qty,
          properties: { 'Cortesia': 'Condicionador de Raiz 🧡' }
        });
      }
      return items;
    }

    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var items = currentItems();
        if (!items) return;
        var original = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.textContent = 'Adicionando…';
        addToCart(items)
          .then(function () {
            addBtn.textContent = 'Adicionado ✓';
            refreshCartBubble();
            refreshOnPageBars();
            tryOpenDrawer();
            setTimeout(function () { addBtn.textContent = original; addBtn.disabled = false; }, 2200);
          })
          .catch(function (err) {
            addBtn.textContent = (err && err.description) ? err.description : 'Erro — tente de novo';
            setTimeout(function () { addBtn.textContent = original; addBtn.disabled = false; }, 2600);
          });
      });
    }

    if (buyBtn) {
      buyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var items = currentItems();
        if (!items) return;
        buyBtn.disabled = true;
        addToCart(items)
          .then(function () { window.location.href = '/checkout'; })
          .catch(function () { buyBtn.disabled = false; });
      });
    }

    /* galeria: miniaturas + setas + arrastar (swipe) */
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-nobs-pp-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-nobs-pp-thumb]'));
    var galMain = root.querySelector('[data-nobs-pp-main]');
    var galIndex = 0;

    function goToSlide(idx) {
      if (!slides.length) return;
      if (idx < 0) idx = slides.length - 1;
      if (idx >= slides.length) idx = 0;
      galIndex = idx;
      slides.forEach(function (s) {
        var active = parseInt(s.dataset.nobsPpSlide, 10) === idx;
        s.hidden = !active;
        if (!active) s.querySelectorAll('video').forEach(function (v) { v.pause(); });
      });
      thumbs.forEach(function (t) {
        var on = parseInt(t.dataset.nobsPpThumb, 10) === idx;
        t.classList.toggle('is-active', on);
        // mantém a miniatura ativa visível SÓ rolando a fileira na horizontal
        // (nunca a página — scrollIntoView rolava a página pra baixo a cada seta)
        if (on) {
          var strip = t.parentElement;
          if (strip && strip.scrollWidth > strip.clientWidth) {
            var sl = strip.getBoundingClientRect();
            var tr = t.getBoundingClientRect();
            if (tr.left < sl.left) strip.scrollLeft += (tr.left - sl.left) - 8;
            else if (tr.right > sl.right) strip.scrollLeft += (tr.right - sl.right) + 8;
          }
        }
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goToSlide(parseInt(thumb.dataset.nobsPpThumb, 10));
      });
    });

    var prevA = root.querySelector('[data-nobs-pp-prev]');
    var nextA = root.querySelector('[data-nobs-pp-next]');
    if (prevA) prevA.addEventListener('click', function () { goToSlide(galIndex - 1); });
    if (nextA) nextA.addEventListener('click', function () { goToSlide(galIndex + 1); });

    // arrastar o dedo (swipe) troca a imagem
    if (galMain && slides.length > 1) {
      var startX = 0, startY = 0;
      galMain.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX; startY = e.touches[0].clientY;
      }, { passive: true });
      galMain.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        // só se o movimento for mais horizontal que vertical (não atrapalha o scroll)
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          goToSlide(galIndex + (dx < 0 ? 1 : -1));
        }
      }, { passive: true });
    }

    sync();
  }

  /* ============ Compre junto ============ */
  function initBundle(root) {
    var totalEl = root.querySelector('[data-nobs-bundle-total]');
    var countEl = root.querySelector('[data-nobs-bundle-count]');
    var addBtn = root.querySelector('[data-nobs-bundle-add]');

    function selected() {
      return Array.prototype.filter.call(
        root.querySelectorAll('[data-nobs-bundle-item]'),
        function (it) { return !it.classList.contains('is-off'); }
      );
    }

    function syncTotal() {
      var items = selected();
      var total = items.reduce(function (s, it) { return s + (parseInt(it.dataset.price, 10) || 0); }, 0);
      if (totalEl) totalEl.textContent = formatCents(total);
      if (countEl) countEl.textContent = items.length;
      if (addBtn) addBtn.disabled = items.length === 0;
    }

    root.querySelectorAll('[data-nobs-bundle-toggle]').forEach(function (chk) {
      chk.addEventListener('click', function () {
        var item = chk.closest('[data-nobs-bundle-item]');
        if (item.dataset.required === 'true') return;
        item.classList.toggle('is-off');
        syncTotal();
      });
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var items = selected().map(function (it) {
          return { id: parseInt(it.dataset.variantId, 10), quantity: 1 };
        }).filter(function (it) { return it.id; });
        if (!items.length) return;
        var original = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.textContent = 'Adicionando…';
        addToCart(items)
          .then(function () {
            addBtn.textContent = 'Adicionado ✓';
            refreshCartBubble();
            refreshOnPageBars();
            tryOpenDrawer();
            setTimeout(function () { addBtn.textContent = original; addBtn.disabled = false; }, 2200);
          })
          .catch(function () {
            addBtn.textContent = 'Erro — tente de novo';
            setTimeout(function () { addBtn.textContent = original; addBtn.disabled = false; }, 2600);
          });
      });
    }

    syncTotal();
  }

  function init() {
    document.querySelectorAll('[data-nobs-pp]').forEach(initProduct);
    document.querySelectorAll('[data-nobs-bundle]').forEach(initBundle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
